<template>
    <v-dialog
      v-model="show"
      max-width="450"
    >
      <v-card>
        <v-card-title class="text-h5">
          Change folder?
        </v-card-title>

        <v-card-text>
          <breadcrumbs
            ref="breadcrumbs"
            mode="button"
            @breadcrumb-click="setParentFolder"
          ></breadcrumbs>

          <v-data-table
            class="elevation-1"
            :items="folders"
            :headers="headers"
            :loading="loading"
            :item-class="'itemasdasd'"
            :hide-default-header="true"
            :hide-default-footer="true"
          >
              <template v-slot:[`item.title`]="{ item }">
                <div
                  class="p-2 d-flex align-center justify-between item"
                  :class="{ selected: item.id === selectedFolderId }"
                  @click="folderClicked(item)"
                >
                  <span :style="{ width: '100%' }">
                    {{ item.title }}
                  </span>
                  <span v-if="item.hasChildFolders">></span>
                </div>
              </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="save">
            Save
          </v-btn>

          <v-btn color="green darken-1" text @click="close">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { getFolderChildren, hasChildFolders, changeVideoParent, changeFolderParent } from './api';
import Breadcrumbs from './Breadcrumbs.vue';

const getFolderVm = (folder) => hasChildFolders(folder.id)
  .then((hasChildFolders) => ({ ...folder, hasChildFolders }));

export default {
  name: 'MoveDialog',
  components: { Breadcrumbs },
  data: () => ({
    loading: false,
    show: false,
    selectedFolderId: null,
    folders: [],
    movableItem: { id: null, isFolder: false },
    headers: [
      {
        text: 'Title',
        align: 'start',
        value: 'title',
        class: 'asdasdas',
        cellClass: 'move-dialog-cell',
      },
    ]
  }),
  computed: {
    breadcrumbs() {
      return this.$refs.breadcrumbs;
    }
  },
  methods: {
    async open(movableItem) {
      this.show = true;
      this.movableItem = movableItem;

      await this.setParentFolder(null);
    },
    async setParentFolder(folderId) {
      await this.getFolders(folderId);
      await this.breadcrumbs.create(folderId);
    },
    async getFolders(folderId) {
      const { id, isFolder } = this.movableItem;

      this.loading = true;

      this.folders = await getFolderChildren(folderId)
        .then(({ folders }) => isFolder ? folders.filter((f) => f.id !== id) : folders)
        .then((folders) => Promise.all(folders.map(getFolderVm)));

      this.loading = false;
    },
    async folderClicked(folder) {
      const { hasChildFolders, id } = folder;
      this.selectedFolderId = id;

      if (hasChildFolders) {
        this.setParentFolder(id);
      }
    },
    save() {
      const { id, isFolder } = this.movableItem;
      const change = isFolder ? changeFolderParent : changeVideoParent;

      change(id, this.selectedFolderId)
        .then(() => this.$emit('update', this.selectedFolderId))
        .then(() => this.close())
    },
    close() {
      this.show = false;
      this.reset();
    },
    reset() {
      this.movableItem = null;
      this.selectedFolderId = null;
      this.folders = [];
    },
  },
}
</script>

<style lang="scss">
.move-dialog-cell {
  padding: 0 !important;
}

.item {
  width: 100%;
  height: 100%;
  padding: 0 16px;

  &.selected {
    background-color: rgba(#40ae75, 0.67) !important;
  }
}
</style>